//1. 导入 Vue 和 VueRouter 的包
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
 
//2. 调用Vue.use()函数，把VueRouter安装为Vue的插件
Vue.use(VueRouter)
 
//3. 创建路由的实例对象
const router = new VueRouter({
    routes
})

//4. 跳转完成后页面回到顶部
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    if (to.query.name) {
        to.meta.title = to.query.name //获取从上个页面传过来的name再进行修改
    }
    next()
})
 
//5. 向外共享路由的实例对象
export default router